"use client"

import { Product } from "@/common/lib/types";
import PublicSaleorClient from "./PublicSaleorClient";
import { GetVariantByIdDocument } from "../generated/graphql";


export async function getVariantsByProductIdClient(
    id: string,
    channel: string
  ): Promise<Product | null> {
    try {
      const saleorClient = new PublicSaleorClient();
  
      if (!id) {
        return null;
      }
  
      const response: { data: { product: Product }; errors: unknown } = await saleorClient.post(
        `${GetVariantByIdDocument}`,
        { id, channel},
        "no-store",
      );
  
      if (response?.errors) {
        return null;
      }
  
      return response?.data?.product as Product|| null;
    } catch (error) {
      throw new Error("Error fetching variants:");
    }
  }